import React from 'react';
import AudioBookItem from '../../components/AudioBookItem/AudioBookItem';
import style from './PodcastSection.module.css';
import mediaItems from '../../jsons/podcast.json'


const PodcastSection = () => {

  return (
    <div className={style.PodcastSectionContainer}>
      {mediaItems.map((item, index) => (
        <AudioBookItem
          key={index}
          type={item.type}
          audioImg={item.image}
          audio={item.source}
        />
      ))}
    </div>
  );
};

export default PodcastSection;
